/* eslint-disable react/jsx-props-no-spreading */
/**
 * @description Renders a date input component for keeping track of the dates related to Personnel Assignment and the contract
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import { DateTime } from 'luxon';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import withErrorBoundary from '@seccon/shared/ui/hocs/with-error-boundary';

/**
 * Validates the date value and, if its invalid, replaces it with a today's date (which is valid)
 * @param {string} value - value to validate
 * @param {() => DateTime} onChange - onChange handling for changing the date to a valid date
 */
function validateDate (value, onChange) {
  if (value === '' || value === 'MM/DD/YYYY') {
    onChange(null)
  } else if (!/\d{2}\/\d{2}\/\d{4}/gi.test(value)) {
    onChange(DateTime.now())
  }
}

const DateInputField = ({ id, required, label }) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={id}
      rules={{
        required
      }}
      render={({ field: { onChange, value } }) => (
        <DatePicker
          label={label}
          onChange={(newValue) => onChange(newValue)}
          slotProps={{
            textField: {
              onBlur: (evt) => validateDate(evt.target.value, onChange),
              size: 'small',
              required
            }
          }}
          value={value ?? null}
        />
      )}
    />
  );
};

DateInputField.propTypes = {
  id: PropTypes.string.isRequired,
  required: PropTypes.bool,
  label: PropTypes.string.isRequired
};

DateInputField.defaultProps = {
  required: false
}

export default withErrorBoundary(DateInputField);
